export function alphabetically(
  field?: string,
  registerSensitivity: 'base' | 'accent' | 'case' | 'variant' = 'base',
  locale = 'ru',
) {
  return (a: any, b: any) => {
    if (field) {
      return Intl.Collator(locale, {
        sensitivity: registerSensitivity,
      }).compare(a[field], b[field])
    }
    return 0
  }
}
